
  import {defineComponent, reactive, onBeforeMount, getCurrentInstance, watch} from 'vue';
  import { Toast } from 'vant';

  export default defineComponent({
    props: {
      show: Boolean,
      title: String,
      width: String,
      message: String,
      confirmText:String,
      cancelText:String,
      isConfirm:Boolean,
      isCancel:Boolean,
      isOverlay:Boolean
    },
    setup(props) {
      const data = reactive({
        show:false
      });

      const pops = reactive({
        ...props
      });

      const { ctx }: any = getCurrentInstance();

      const close = () => {
        data.show = false;
      };

      const open = () => {
        data.show = true;
      };

      const onConfirm = () => {
        ctx.$emit("confirm");
        close();
      };

      const onCancel = () => {
        ctx.$emit("cancel");
        close();
      };

      onBeforeMount(() => {

      });
      return {
        close,
        open,
        data,
        pops,
        onConfirm,
        onCancel
      };
    }
  });
